// import analytics from '@utils/analytics';
import analytics from '@stone/utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
const SizeGuideButton = (props) => {
    const { t } = useTranslation();
    return (React.createElement("button", { type: "button", className: "button button--tertiary findmysize-cta", onClick: () => {
            props.onSizeGuideOpen();
            (props === null || props === void 0 ? void 0 : props.pid) && analytics.findMySize(props.pid, 'click');
        }, "aria-haspopup": props.withAria ? 'dialog' : undefined },
        React.createElement("span", { className: "btn-label-find-size" }, t('sizeguide.findmysizecta'))));
};
export default SizeGuideButton;
